import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faArrowRight, faCheck} from '@fortawesome/free-solid-svg-icons'
import logoImage from '../img/consultMidiaLogo.png';
import {useHistory} from "react-router-dom";
import InputMask from "react-input-mask";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import React, { useState} from "react";
import FacebookPixel from "../capturePixel/Facebook";


export function ThirdQuestion() {
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const history = useHistory();

    const MySwal = withReactContent(Swal);

    function handleQuestion() {
        const phoneNumberValue = document.getElementById("numberInput") as HTMLInputElement;

        if (validateNumber()) {
            sessionStorage.setItem('phoneNumber', phoneNumberValue.value);
            history.push('/fourth');
        } else {
            MySwal.fire({
                icon: 'error',
                title: '',
                text: "Número Inválido",
                showConfirmButton: false,
                timer: 1500,
            })
        }
    }

    function validateNumber() {
        return phoneNumber.replace(/\D/g, "").length === 11;
    }

    function clickButton(event: React.KeyboardEvent<HTMLInputElement>) {
        const buttonSubmit = document.getElementById("buttonSubmit") as HTMLButtonElement;
        if (event.key === "Enter") {
            buttonSubmit.click();
        }
    }

    return (
        <>
            <FacebookPixel nameTracking="Third"/>
            <div className="progress">
                <div className="progress-bar progress-bar-60" role="progressbar"/>
            </div>
            <div className="container container-fluid">
                <div className=" d-block d-md-none">
                    <img className="img-fluid image" src={logoImage} alt="logo"/>
                </div>
                <section className="container-body">
                    <div className="row d-flex flex-column align-content-lg-start">
                        <div className="col-lg-2 col-xs-12 col-centered">
                            <span>3<FontAwesomeIcon icon={faArrowRight}/></span>
                        </div>
                        <div className="col-lg-10 align-self-end mr-5">
                            <span className="span">Ótimo, agora nos diga qual o seu WhatsApp?</span>
                            <div className="py-2 pr-4">
                                <InputMask autoFocus className="input" onKeyDown={clickButton} id="numberInput"
                                           mask="(99) 99999-9999"
                                           alwaysShowMask={false} value={phoneNumber} onChange={(event) => {
                                    setPhoneNumber(event.target.value)
                                }} placeholder="(11) 93333-3333"/>
                            </div>
                        </div>
                    </div>
                    <div className="row mr-5">
                        <div className="col-lg-2">
                            <button id="buttonSubmit" onClick={handleQuestion}>Próximo<FontAwesomeIcon icon={faCheck}/>
                            </button>
                        </div>
                        <div className="col-lg-10 confirmation">
                            Pressione <strong>Enter ↵</strong>
                        </div>
                    </div>
                </section>
            </div>
        </>

    );
}